export default () => ({
  isMobile: true,
  isExtraSmallMobile: true,
  isAdhdFocusActive: true
})
